import React, {useMemo} from 'react';
import { ResponsiveLine } from '@nivo/line';
import { Switch, Slider, Row, Col, Space, Typography } from 'antd';
import useNivoCharts from './useNivoCharts';


const NivoLineController = ({ data, xScale, yScale, config, setConfig, xTitle='', yTitle='',
height=500, width='100%'}) => {
    // Get common Nivo chart settings
    const { commonSettings } = useNivoCharts();

    const handleSetConfig = (key, value) => {
        setConfig(prevConfig => ({
            ...prevConfig,
            [key]: value
        }));
    }
    const getColor = line => line?.color; // Default to black if no color is provided
    const legendMapping = useMemo(() => data.map(d => ({ id: d.id, color: getColor(d) })), [data]);

    return (
        <Row wrap={false} style={{width, margin: 'auto'}}>
            <Col flex={'auto'}>
                <div style={{ display: 'flex', height }}>
            {/* Controller menu */}

            {/* Nivo Line Chart */}
            <div style={{ flex: 1 }}>
                <ResponsiveLine
                    data={data}
                    margin={{ top: 50, right: 50, bottom: 50, left: 70 }}
                    xScale={xScale}
                    lineWidth={config?.lineWidth}
                    pointSize={config?.pointSize}
                    enablePoints={config?.enablePoints}
                    yScale={yScale}
                    enableSlices={'x'}
                    axisBottom={{
                        orient: 'bottom',
                        tickValues: 'every 5',
                        legend: config?.xTitle ?? xTitle,
                        legendOffset: 36,
                        legendPosition: 'middle',
                    }}
                    axisLeft={{
                        orient: 'left',
                        tickValues: 10,
                        format: value => `${value}%`,
                        legend: config?.yTitle ?? yTitle,
                        legendOffset: -60,
                        legendPosition: 'middle',
                    }}
                    grid={{
                        xValues: [],  // Remove vertical gridlines
                        yValues: 5,   // Keep horizontal gridlines (adjust as needed)
                    }}
                    enableArea={config?.isArea}
                    areaOpacity={config?.areaOpacity}
                    {...commonSettings} // Spread in common settings
                    colors={getColor}
                    legends={[]} // Set to an empty array to hide the legend

                />
            </div>
        </div>
            </Col>
            <Col flex={'0 0 200px'}>
                <Space direction={'vertical'}>
                    {legendMapping.map(({ id, color }) => (
                        <div className={'my-3 dropped-shadow'} style={{borderRadius: '25px', background: `linear-gradient(to right, ${color}, ${color} 15px, rgba(255, 255, 255, 0.06) 15px)`}}>
                            <Space wrap={false}>
                                {/*<div style={{backgroundColor: color, width: '20px', height: '20px', borderRadius: '50%'}}></div>*/}
                                <Typography.Text style={{fontSize: '11px', paddingLeft: '20px'}} ellipsis={{rows: 1}}>{id}</Typography.Text>
                            </Space>
                        </div>
                    ))}
                </Space>
            </Col>
        </Row>
    );
};

export default NivoLineController;
